import EventsService from "../../services/EventsService";
import LocationService from "../../services/LocationService";

export const GET_EVENT_REQUEST = "GET_EVENT_REQUEST";
export const GET_EVENT_SUCCESS = "GET_EVENT_SUCCESS";
export const GET_EVENT_ERROR = "GET_EVENT_ERROR";

export const GET_USER_EVENTS_REQUEST = "GET_USER_EVENTS_REQUEST";
export const GET_USER_EVENTS_SUCCESS = "GET_USER_EVENTS_SUCCESS";
export const GET_USER_EVENTS_ERROR = "GET_USER_EVENTS_ERROR";

export const GET_EVENT_DATES_REQUEST = "GET_EVENT_DATES_REQUEST";
export const GET_EVENT_DATES_SUCCESS = "GET_EVENT_DATES_SUCCESS";
export const GET_EVENT_DATES_ERROR = "GET_EVENT_DATES_ERROR";

export const GET_DATE_REQUEST = "GET_DATE_REQUEST";
export const GET_DATE_SUCCESS = "GET_DATE_SUCCESS";
export const GET_DATE_ERROR = "GET_DATE_ERROR";

export const GET_NEAREST_EVENT_DATES_REQUEST =
  "GET_NEAREST_EVENT_DATES_REQUEST";
export const GET_NEAREST_EVENT_DATES_SUCCESS =
  "GET_NEAREST_EVENT_DATES_SUCCESS";
export const GET_NEAREST_EVENT_DATES_ERROR = "GET_NEAREST_EVENT_DATES_ERROR";

export const SET_WIDGET = "SET_WIDGET";

export const GET_ADDITIONAL_QUESTION_WITH_QUANTITY_SUCCESS =
  "GET_ADDITIONAL_QUESTION_WITH_QUANTITY_SUCCESS";

export const CLEAR_EVENT = "CLEAR_EVENT";

import { loadTickets } from "./ticketsActions";

import { getOrder } from "./orderActions";

export const getEvent = (
  slug,
  token,
  getTickets,
  orderId,
  getMerch = false,
  eventDateId = null
) => {
  return (dispatch, getState) => {
    dispatch({ type: GET_EVENT_REQUEST, slug });
    EventsService.get(slug, token, orderId, eventDateId)
      .then(event => {
        LocationService.setEventLocation(event.location);
        dispatch({ type: GET_EVENT_SUCCESS, event });
        if (getTickets) {
          const state = getState();
          loadTickets(
            state.event.id,
            state.ticketSelection.selectedDateId
          )(dispatch);
        }
        if (orderId) {
          getOrder(orderId, getMerch)(dispatch);
        }
      })
      .catch(err => {
        dispatch({ type: GET_EVENT_ERROR, error: err });
      });
  };
};

export const getEventPublic = (eventId, orderId, token) => {
  return async dispatch => {
    try {
      dispatch({ type: GET_EVENT_REQUEST });
      const event = await EventsService.getEventPublic(eventId, orderId, token);
      LocationService.setEventLocation(event.location);
      dispatch({ type: GET_EVENT_SUCCESS, event });
    } catch (err) {
      dispatch({ type: GET_EVENT_ERROR, error: err });
    }
  };
};
// slug can be either userId or organiserId
export const getUserEvents = (userId, organiserId) => {
  return dispatch => {
    dispatch({ type: GET_USER_EVENTS_REQUEST, userId, organiserId });
    EventsService.getAllByUser(userId, organiserId)
      .then(events => {
        dispatch({ type: GET_USER_EVENTS_SUCCESS, events });
      })
      .catch(err => {
        dispatch({ type: GET_USER_EVENTS_ERROR, error: err });
      });
  };
};

export const getDates = (eventId, month, year, date) => {
  return dispatch => {
    dispatch({ type: GET_EVENT_DATES_REQUEST, month: date });
    EventsService.getDates(eventId, month, year)
      .then(dates => {
        dispatch({ type: GET_EVENT_DATES_SUCCESS, dates });
      })
      .catch(err => {
        dispatch({ type: GET_EVENT_DATES_ERROR, error: err });
      });
  };
};

export const getDate = (eventSlug, eventDateId) => {
  return dispatch => {
    dispatch({ type: GET_DATE_REQUEST });
    EventsService.getDate(eventSlug, eventDateId)
      .then(date => {
        dispatch({ type: GET_DATE_SUCCESS, date });
      })
      .catch(err => {
        dispatch({ type: GET_DATE_ERROR, error: err });
      });
  };
};

export const getNextAvailableDates = eventId => {
  return dispatch => {
    dispatch({ type: GET_NEAREST_EVENT_DATES_REQUEST });
    EventsService.getNearestDate(eventId)
      .then(data => {
        dispatch({
          type: GET_NEAREST_EVENT_DATES_SUCCESS,
          month: new Date(data.month),
          dates: data.dates
        });
      })
      .catch(err => {
        dispatch({ type: GET_NEAREST_EVENT_DATES_ERROR, error: err });
      });
  };
};

export const getAdditionalQuestionsPreview = eventSlug => {
  return dispatch => {
    dispatch({ type: GET_EVENT_REQUEST });
    EventsService.getAdditionalQuestionsPreview(eventSlug)
      .then(event => {
        dispatch({
          type: GET_EVENT_SUCCESS,
          event
        });
      })
      .catch(err => {
        dispatch({ type: GET_EVENT_ERROR, error: err });
      });
  };
};

export const getCompleteMessagePreview = eventSlug => {
  return dispatch => {
    dispatch({ type: GET_EVENT_REQUEST });
    EventsService.getCompleteMessagePreview(eventSlug)
      .then(event => {
        dispatch({
          type: GET_EVENT_SUCCESS,
          event
        });
      })
      .catch(err => {
        dispatch({ type: GET_EVENT_ERROR, error: err });
      });
  };
};

export const clearEvent = () => {
  return dispatch => {
    dispatch({ type: CLEAR_EVENT });
  };
};
